import React from 'react';

interface SearchBarProps {
  query: string;
  setQuery: (query: string) => void;
  onSearch: () => void;
  onUseLocation: () => void;
  isLoading: boolean;
  resultLimit: string;
  setResultLimit: (limit: string) => void;
}

const LocationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
      <path fillRule="evenodd" d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.979.573.573.573 0 00.28.14l.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" clipRule="evenodd" />
    </svg>
  );

export const SearchBar: React.FC<SearchBarProps> = ({ query, setQuery, onSearch, onUseLocation, isLoading, resultLimit, setResultLimit }) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-center gap-2 w-full">
      <div className="relative flex-grow w-full">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="e.g., bakeries within 10 miles of Byhalia, MS"
          className="w-full pl-4 pr-12 py-3 bg-slate-700 text-slate-100 border border-slate-600 rounded-lg placeholder-slate-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
          disabled={isLoading}
        />
        <button
            onClick={onUseLocation}
            disabled={isLoading}
            className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-cyan-400 disabled:text-slate-600 disabled:cursor-not-allowed transition-colors"
            title="Use current location in query"
        >
           <LocationIcon />
        </button>
      </div>
      <div className="flex items-center gap-2 w-full sm:w-auto">
        <select
          value={resultLimit}
          onChange={(e) => setResultLimit(e.target.value)}
          disabled={isLoading}
          className="w-full sm:w-auto px-4 py-3 bg-slate-700 border border-slate-600 text-slate-100 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors appearance-none text-center"
          style={{ backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%2394a3b8\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")', backgroundPosition: 'right 0.5rem center', backgroundRepeat: 'no-repeat', backgroundSize: '1.5em 1.5em', paddingRight: '2.5rem' }}
        >
          <option value="20">Default (20)</option>
          <option value="50">More (50)</option>
          <option value="100">Maximum (100+)</option>
        </select>
        <button
          onClick={onSearch}
          disabled={isLoading}
          className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all transform active:scale-95"
        >
          Search
        </button>
      </div>
    </div>
  );
};
